export const ACCOUNT_TYPE = {
    ADMIN:"Admin",
    USER:"User"
}

export const COUPON_TYPE = {
    PUBLIC:"Public",
    PRIVATE:"Private"
}

// Predefined locations data for Panchang
export const LOCATIONS = [
  { name: "New Delhi", state: "Delhi (NCT)", coordinates: "28.6139,77.2090" },
  { name: "Mumbai", state: "Maharashtra", coordinates: "19.0760,72.8777" },
  { name: "Bengaluru", state: "Karnataka", coordinates: "12.9716,77.5946" },
  { name: "Chennai", state: "Tamil Nadu", coordinates: "13.0827,80.2707" },
  { name: "Kolkata", state: "West Bengal", coordinates: "22.5726,88.3639" },
  { name: "Hyderabad", state: "Telangana", coordinates: "17.3850,78.4867" },
  { name: "Pune", state: "Maharashtra", coordinates: "18.5204,73.8567" },
  { name: "Ahmedabad", state: "Gujarat", coordinates: "23.0225,72.5714" },
  { name: "Jaipur", state: "Rajasthan", coordinates: "26.9124,75.7873" },
  { name: "Lucknow", state: "Uttar Pradesh", coordinates: "26.8467,80.9462" },
  { name: "Kanpur", state: "Uttar Pradesh", coordinates: "26.4499,80.3319" },
  { name: "Nagpur", state: "Maharashtra", coordinates: "21.1458,79.0882" },
  { name: "Indore", state: "Madhya Pradesh", coordinates: "22.7196,75.8577" },
  { name: "Thiruvananthapuram", state: "Kerala", coordinates: "8.5241,76.9366" },
  { name: "Bhopal", state: "Madhya Pradesh", coordinates: "23.2599,77.4126" },
  { name: "Visakhapatnam", state: "Andhra Pradesh", coordinates: "17.6868,83.2185" },
  { name: "Pimpri-Chinchwad", state: "Maharashtra", coordinates: "18.6298,73.7997" },
  { name: "Patna", state: "Bihar", coordinates: "25.5941,85.1376" },
  { name: "Vadodara", state: "Gujarat", coordinates: "22.3072,73.1812" },
  { name: "Ghaziabad", state: "Uttar Pradesh", coordinates: "28.6692,77.4538" },
  { name: "Ludhiana", state: "Punjab", coordinates: "30.9010,75.8573" },
  { name: "Agra", state: "Uttar Pradesh", coordinates: "27.1767,78.0081" },
  { name: "Nashik", state: "Maharashtra", coordinates: "19.9975,73.7898" },
  { name: "Faridabad", state: "Haryana", coordinates: "28.4089,77.3178" },
  { name: "Meerut", state: "Uttar Pradesh", coordinates: "28.9845,77.7064" },
  { name: "Rajkot", state: "Gujarat", coordinates: "22.3039,70.8022" },
  { name: "Kalyan-Dombivali", state: "Maharashtra", coordinates: "19.2403,73.1305" },
  { name: "Vasai-Virar", state: "Maharashtra", coordinates: "19.4259,72.8225" },
  { name: "Varanasi", state: "Uttar Pradesh", coordinates: "25.3176,82.9739" },
  { name: "Srinagar", state: "Jammu & Kashmir", coordinates: "34.0837,74.7973" },
  { name: "Aurangabad", state: "Maharashtra", coordinates: "19.8762,75.3433" },
  { name: "Navi Mumbai", state: "Maharashtra", coordinates: "19.0330,73.0297" },
  { name: "Solapur", state: "Maharashtra", coordinates: "17.6599,75.9064" },
  { name: "Vijayawada", state: "Andhra Pradesh", coordinates: "16.5062,80.6480" },
  { name: "Kolhapur", state: "Maharashtra", coordinates: "16.7050,74.2433" },
  { name: "Amritsar", state: "Punjab", coordinates: "31.6340,74.8723" },
  { name: "Noida", state: "Uttar Pradesh", coordinates: "28.5355,77.3910" },
  { name: "Ranchi", state: "Jharkhand", coordinates: "23.3441,85.3096" },
  { name: "Howrah", state: "West Bengal", coordinates: "22.5958,88.2636" },
  { name: "Coimbatore", state: "Tamil Nadu", coordinates: "11.0168,76.9558" },
  { name: "Raipur", state: "Chhattisgarh", coordinates: "21.2514,81.6296" },
  { name: "Jabalpur", state: "Madhya Pradesh", coordinates: "23.1815,79.9864" },
  { name: "Gwalior", state: "Madhya Pradesh", coordinates: "26.2183,78.1828" },
  { name: "Chandigarh", state: "Chandigarh", coordinates: "30.7333,76.7794" },
  { name: "Tiruchirappalli", state: "Tamil Nadu", coordinates: "10.7905,78.7047" },
  { name: "Mysore", state: "Karnataka", coordinates: "12.2958,76.6394" },
  { name: "Bhubaneswar", state: "Odisha", coordinates: "20.2961,85.8245" },
  { name: "Kochi", state: "Kerala", coordinates: "9.9312,76.2673" },
  { name: "Bhavnagar", state: "Gujarat", coordinates: "21.7645,72.1519" },
  { name: "Salem", state: "Tamil Nadu", coordinates: "11.6643,78.1460" },
  { name: "Warangal", state: "Telangana", coordinates: "17.9689,79.5941" },
  { name: "Guntur", state: "Andhra Pradesh", coordinates: "16.3067,80.4365" },
  { name: "Bhiwandi", state: "Maharashtra", coordinates: "19.3002,73.0582" },
  { name: "Amravati", state: "Maharashtra", coordinates: "20.9374,77.7796" },
  { name: "Nanded", state: "Maharashtra", coordinates: "19.1383,77.3210" },
  { name: "Kolhapur", state: "Maharashtra", coordinates: "16.7050,74.2433" },
  { name: "Sangli", state: "Maharashtra", coordinates: "16.8524,74.5815" },
  { name: "Malegaon", state: "Maharashtra", coordinates: "20.5597,74.5255" },
  { name: "Ulhasnagar", state: "Maharashtra", coordinates: "19.2215,73.1645" },
  { name: "Jalgaon", state: "Maharashtra", coordinates: "21.0077,75.5626" },
  { name: "Latur", state: "Maharashtra", coordinates: "18.4088,76.5604" },
  { name: "Ahmadnagar", state: "Maharashtra", coordinates: "19.0952,74.7496" },
  { name: "Dhule", state: "Maharashtra", coordinates: "20.9013,74.7774" },
  { name: "Ichalkaranji", state: "Maharashtra", coordinates: "16.7040,74.4563" },
  { name: "Parbhani", state: "Maharashtra", coordinates: "19.2603,76.7821" },
  { name: "Jalna", state: "Maharashtra", coordinates: "19.8410,75.8864" },
  { name: "Bhusawal", state: "Maharashtra", coordinates: "21.0436,75.7851" },
  { name: "Panchkula", state: "Haryana", coordinates: "30.6942,76.8606" },
  { name: "Karnal", state: "Haryana", coordinates: "29.6857,76.9905" },
  { name: "Hisar", state: "Haryana", coordinates: "29.1492,75.7217" },
  { name: "Ambala", state: "Haryana", coordinates: "30.3753,76.7821" },
  { name: "Yamunanagar", state: "Haryana", coordinates: "30.1290,77.2674" },
  { name: "Rohtak", state: "Haryana", coordinates: "28.8955,76.6066" },
  { name: "Gurgaon", state: "Haryana", coordinates: "28.4595,77.0266" },
  { name: "Sonipat", state: "Haryana", coordinates: "28.9931,77.0151" },
  { name: "Panipat", state: "Haryana", coordinates: "29.3909,76.9635" },
  { name: "Sirsa", state: "Haryana", coordinates: "29.5350,75.0286" },
  { name: "Bahadurgarh", state: "Haryana", coordinates: "28.6929,76.9256" },
  { name: "Jind", state: "Haryana", coordinates: "29.3160,76.3155" },
  { name: "Thanesar", state: "Haryana", coordinates: "29.9680,76.8325" },
  { name: "Kaithal", state: "Haryana", coordinates: "29.8015,76.3998" },
  { name: "Rewari", state: "Haryana", coordinates: "28.1993,76.6193" },
  { name: "Palwal", state: "Haryana", coordinates: "28.1449,77.3254" },
  { name: "Bhiwani", state: "Haryana", coordinates: "28.7930,76.1398" },
  { name: "Ambala", state: "Haryana", coordinates: "30.3753,76.7821" },
  { name: "Chandigarh", state: "Chandigarh", coordinates: "30.7333,76.7794" },
  { name: "Shimla", state: "Himachal Pradesh", coordinates: "31.1048,77.1734" },
  { name: "Dharamshala", state: "Himachal Pradesh", coordinates: "32.2190,76.3234" },
  { name: "Solan", state: "Himachal Pradesh", coordinates: "30.9045,77.0967" },
  { name: "Mandi", state: "Himachal Pradesh", coordinates: "31.7089,76.9324" },
  { name: "Palampur", state: "Himachal Pradesh", coordinates: "32.1145,76.5562" },
  { name: "Kullu", state: "Himachal Pradesh", coordinates: "31.9566,77.1095" },
  { name: "Manali", state: "Himachal Pradesh", coordinates: "32.2396,77.1887" },
  { name: "Dalhousie", state: "Himachal Pradesh", coordinates: "32.5334,75.9463" },
  { name: "Chamba", state: "Himachal Pradesh", coordinates: "32.5555,76.1264" },
  { name: "Una", state: "Himachal Pradesh", coordinates: "31.4649,76.2691" },
  { name: "Bilaspur", state: "Himachal Pradesh", coordinates: "31.3392,76.7569" },
  { name: "Hamirpur", state: "Himachal Pradesh", coordinates: "31.6862,76.5206" },
  { name: "Kangra", state: "Himachal Pradesh", coordinates: "32.1000,76.2667" },
  { name: "Kinnaur", state: "Himachal Pradesh", coordinates: "31.5833,78.4167" },
  { name: "Lahaul and Spiti", state: "Himachal Pradesh", coordinates: "32.5000,77.8333" },
  { name: "Sirmaur", state: "Himachal Pradesh", coordinates: "30.7500,77.5000" },
  { name: "Dehradun", state: "Uttarakhand", coordinates: "30.3165,78.0322" },
  { name: "Haridwar", state: "Uttarakhand", coordinates: "29.9457,78.1642" },
  { name: "Rishikesh", state: "Uttarakhand", coordinates: "30.0869,78.2676" },
  { name: "Nainital", state: "Uttarakhand", coordinates: "29.3919,79.4542" },
  { name: "Mussoorie", state: "Uttarakhand", coordinates: "30.4546,78.0708" },
  { name: "Almora", state: "Uttarakhand", coordinates: "29.5973,79.6571" },
  { name: "Pithoragarh", state: "Uttarakhand", coordinates: "29.5820,80.2183" },
  { name: "Rudrapur", state: "Uttarakhand", coordinates: "28.9800,79.4000" },
  { name: "Kashipur", state: "Uttarakhand", coordinates: "29.2167,78.9500" },
  { name: "Haldwani", state: "Uttarakhand", coordinates: "29.2167,79.5167" },
  { name: "Roorkee", state: "Uttarakhand", coordinates: "29.8667,77.8833" },
  { name: "Kotdwar", state: "Uttarakhand", coordinates: "29.7500,78.1333" },
  { name: "Srinagar", state: "Uttarakhand", coordinates: "30.2226,78.7834" },
  { name: "Tehri", state: "Uttarakhand", coordinates: "30.3833,78.4833" },
  { name: "Pauri", state: "Uttarakhand", coordinates: "30.1500,78.7833" },
  { name: "Chamoli", state: "Uttarakhand", coordinates: "30.4167,79.3333" },
  { name: "Uttarkashi", state: "Uttarakhand", coordinates: "30.7333,78.4500" },
  { name: "Bageshwar", state: "Uttarakhand", coordinates: "29.8500,79.7667" },
  { name: "Champawat", state: "Uttarakhand", coordinates: "29.3333,80.1000" },
  { name: "Rudraprayag", state: "Uttarakhand", coordinates: "30.2833,78.9833" },
  { name: "Udhampur", state: "Jammu & Kashmir", coordinates: "32.9167,75.1333" },
  { name: "Jammu", state: "Jammu & Kashmir", coordinates: "32.7333,74.8667" },
  { name: "Kathua", state: "Jammu & Kashmir", coordinates: "32.3833,75.5167" },
  { name: "Samba", state: "Jammu & Kashmir", coordinates: "32.5667,75.1167" },
  { name: "Rajouri", state: "Jammu & Kashmir", coordinates: "33.3833,74.3000" },
  { name: "Poonch", state: "Jammu & Kashmir", coordinates: "33.7667,74.1000" },
  { name: "Doda", state: "Jammu & Kashmir", coordinates: "33.1500,75.5500" },
  { name: "Kishtwar", state: "Jammu & Kashmir", coordinates: "33.3167,75.7667" },
  { name: "Ramban", state: "Jammu & Kashmir", coordinates: "33.2500,75.2333" },
  { name: "Reasi", state: "Jammu & Kashmir", coordinates: "33.0833,74.8333" },
  { name: "Kulgam", state: "Jammu & Kashmir", coordinates: "33.6500,75.0167" },
  { name: "Shopian", state: "Jammu & Kashmir", coordinates: "33.7167,74.8333" },
  { name: "Pulwama", state: "Jammu & Kashmir", coordinates: "33.8667,74.9000" },
  { name: "Budgam", state: "Jammu & Kashmir", coordinates: "33.9333,74.6333" },
  { name: "Ganderbal", state: "Jammu & Kashmir", coordinates: "34.2167,74.7833" },
  { name: "Bandipora", state: "Jammu & Kashmir", coordinates: "34.4167,74.6500" },
  { name: "Baramulla", state: "Jammu & Kashmir", coordinates: "34.2000,74.3500" },
  { name: "Kupwara", state: "Jammu & Kashmir", coordinates: "34.5167,74.2667" },
  { name: "Anantnag", state: "Jammu & Kashmir", coordinates: "33.7333,75.1500" },
  { name: "Kargil", state: "Ladakh", coordinates: "34.5500,76.1167" },
  { name: "Leh", state: "Ladakh", coordinates: "34.1526,77.5770" },
  { name: "Puducherry", state: "Puducherry", coordinates: "11.9416,79.8083" },
  { name: "Karaikal", state: "Puducherry", coordinates: "10.9167,79.8333" },
  { name: "Mahe", state: "Puducherry", coordinates: "11.7000,75.5333" },
  { name: "Yanam", state: "Puducherry", coordinates: "16.7333,82.2167" },
  { name: "Port Blair", state: "Andaman & Nicobar", coordinates: "11.6234,92.7265" },
  { name: "Daman", state: "Dadra & Nagar Haveli and Daman & Diu", coordinates: "20.3974,72.8328" },
  { name: "Diu", state: "Dadra & Nagar Haveli and Daman & Diu", coordinates: "20.7144,70.9874" },
  { name: "Silvassa", state: "Dadra & Nagar Haveli and Daman & Diu", coordinates: "20.2736,73.0232" },
  { name: "Kavaratti", state: "Lakshadweep", coordinates: "10.5667,72.6420" },
  { name: "Amaravati", state: "Andhra Pradesh", coordinates: "16.5417,80.6305" },
  { name: "Itanagar", state: "Arunachal Pradesh", coordinates: "27.0844,93.6053" },
  { name: "Dispur", state: "Assam", coordinates: "26.1433,91.7898" },
  { name: "Gangtok", state: "Sikkim", coordinates: "27.3389,88.6065" },
  { name: "Agartala", state: "Tripura", coordinates: "23.8315,91.2868" },
  { name: "Aizawl", state: "Mizoram", coordinates: "23.7271,92.7176" },
  { name: "Imphal", state: "Manipur", coordinates: "24.8170,93.9368" },
  { name: "Shillong", state: "Meghalaya", coordinates: "25.5788,91.8933" },
  { name: "Kohima", state: "Nagaland", coordinates: "25.6747,94.1100" },
  { name: "Panaji", state: "Goa", coordinates: "15.4909,73.8278" },
  { name: "Gandhinagar", state: "Gujarat", coordinates: "23.2156,72.6369" },
  { name: "Madhubani", state: "Bihar", coordinates: "26.347883,86.071861" }
];

// Temple data for the temple page
export const TEMPLES_DATA = [
  {
    id: 'kashi',
    name: 'Kashi Vishwanath',
    location: 'Varanasi, Uttar Pradesh',
    deity: 'Lord Shiva',
    rating: 4.8,
    image: 'https://images.unsplash.com/photo-1581089781785-603411fa81e2?auto=format&fit=crop&w=600&q=80',
    status: 'coming-soon',
    description: 'One of the most sacred Shiva temples and a major pilgrimage destination.',
    emoji: '🕉️'
  },
  {
    id: 'jagannath',
    name: 'Jagannath Puri',
    location: 'Puri, Odisha',
    deity: 'Lord Jagannath',
    rating: 4.9,
    image: 'https://images.unsplash.com/photo-1578894381163-e72c17f3fd49?auto=format&fit=crop&w=600&q=80',
    status: 'coming-soon',
    description: 'Famous for the annual Rath Yatra and one of the Char Dham pilgrimage sites.',
    emoji: '🪷'
  },
  {
    id: 'vaishno-devi',
    name: 'Vaishno Devi',
    location: 'Katra, Jammu & Kashmir',
    deity: 'Goddess Vaishno Devi',
    rating: 4.9,
    image: 'https://images.unsplash.com/photo-1605640840605-14ac1855827b?auto=format&fit=crop&w=600&q=80',
    status: 'coming-soon',
    description: 'One of the most revered Shakti Peethas, located in the Trikuta Mountains.',
    emoji: '🔥'
  },
  {
    id: 'haridwar',
    name: 'Har Ki Pauri',
    location: 'Haridwar, Uttarakhand',
    deity: 'Lord Shiva',
    rating: 4.7,
    image: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?auto=format&fit=crop&w=600&q=80',
    status: 'coming-soon',
    description: 'Sacred ghat on the Ganges where devotees perform evening Ganga Aarti.',
    emoji: '🕉️'
  },
  {
    id: 'lokhnath',
    name: 'Lokhnath Temple',
    location: 'Puri, Odisha',
    deity: 'Lord Shiva',
    rating: 4.6,
    image: 'https://images.unsplash.com/photo-1609920658906-8223bd289001?auto=format&fit=crop&w=600&q=80',
    status: 'coming-soon',
    description: 'Ancient Shiva temple known for its unique architecture and spiritual significance.',
    emoji: '🕉️'
  },
  {
    id: 'kamakhya',
    name: 'Kamakhya Temple',
    location: 'Guwahati, Assam',
    deity: 'Goddess Kamakhya',
    rating: 4.8,
    image: 'https://images.unsplash.com/photo-1570197788417-0e82375c9371?auto=format&fit=crop&w=600&q=80',
    status: 'coming-soon',
    description: 'One of the most important Shakti Peethas, dedicated to the goddess of desire.',
    emoji: '🔥'
  },
  {
    id: 'tirupati',
    name: 'Tirupati Balaji',
    location: 'Tirupati, Andhra Pradesh',
    deity: 'Lord Venkateswara',
    rating: 4.9,
    image: 'https://images.unsplash.com/photo-1605640840605-14ac1855827b?auto=format&fit=crop&w=600&q=80',
    status: 'coming-soon',
    description: 'One of the richest temples in the world, dedicated to Lord Venkateswara.',
    emoji: '🪷'
  },
  {
    id: 'golden-temple',
    name: 'Golden Temple',
    location: 'Amritsar, Punjab',
    deity: 'Sikh Shrine',
    rating: 4.9,
    image: 'https://images.unsplash.com/photo-1609920658906-8223bd289001?auto=format&fit=crop&w=600&q=80',
    status: 'coming-soon',
    description: 'The holiest Sikh shrine, known for its golden dome and spiritual significance.',
    emoji: '🙏'
  },
  {
    id: 'somnath',
    name: 'Somnath Temple',
    location: 'Gujarat',
    deity: 'Lord Shiva',
    rating: 4.7,
    image: 'https://images.unsplash.com/photo-1605640840605-14ac1855827b?auto=format&fit=crop&w=600&q=80',
    status: 'coming-soon',
    description: 'First among the twelve Jyotirlingas of Lord Shiva, located by the Arabian Sea.',
    emoji: '🕉️'
  },
  {
    id: 'meenakshi',
    name: 'Meenakshi Temple',
    location: 'Madurai, Tamil Nadu',
    deity: 'Goddess Meenakshi',
    rating: 4.8,
    image: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?auto=format&fit=crop&w=600&q=80',
    status: 'coming-soon',
    description: 'Historic temple dedicated to Goddess Meenakshi with stunning Dravidian architecture.',
    emoji: '🔥'
  }
];

// Featured temple data
export const FEATURED_TEMPLE = {
  id: 'ucchait',
  name: 'Ucchait Bhagwati Temple',
  location: 'Sitamarhi, Bihar, India',
  deity: 'Goddess Durga',
  rating: 4.9,
  image: 'https://images.unsplash.com/photo-1564507592333-c60657eea523?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  status: 'live',
  description: 'Ucchait Bhagwati Temple is a revered shrine dedicated to Goddess Durga. Known for its spiritual significance and divine atmosphere, this temple attracts thousands of devotees seeking blessings and peace.',
  emoji: '🔥',
  timings: 'Open: 5:00 AM - 10:00 PM',
  visitors: '2,847 devotees visiting today'
};

// Temple categories data
export const TEMPLE_CATEGORIES = [
  { name: 'Shiva Temples', count: 12, icon: '🕉️' },
  { name: 'Vishnu Temples', count: 8, icon: '🪷' },
  { name: 'Devi Temples', count: 15, icon: '🔥' },
  { name: 'Other Deities', count: 10, icon: '⭐' }
];

// Detailed temple information for temple detail pages
export const TEMPLE_DETAILS = {
  'kashi': {
    id: 'kashi',
    name: 'Kashi Vishwanath Temple',
    location: 'Varanasi, Uttar Pradesh',
    deity: 'Lord Shiva',
    rating: 4.8,
    heroImage: 'https://images.unsplash.com/photo-1581089781785-603411fa81e2?auto=format&fit=crop&w=1200&q=80',
    description: 'The Kashi Vishwanath Temple is one of the most sacred Hindu temples dedicated to Lord Shiva. Located in the holy city of Varanasi, Uttar Pradesh, it stands on the western bank of the river Ganga. The temple is among the 12 Jyotirlingas, the holiest Shiva temples. Every year, millions of devotees visit to seek blessings and experience spiritual energy.',
    timings: 'Open: 4:00 AM – 11:00 PM',
    visitors: '15,000+ devotees visit daily',
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3559.2055537056796!2d83.0094764150541!3d25.3109217838577!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398e2e2f4c09eeb7%3A0x9dfb12d4b7e9a2c7!2sKashi%20Vishwanath%20Temple!5e0!3m2!1sen!2sin!4v1674567890123',
    relatedTemples: [
      { id: 'jagannath', name: 'Jagannath Puri', location: 'Odisha', image: 'https://images.unsplash.com/photo-1578894381163-e72c17f3fd49?auto=format&fit=crop&w=600&q=80' },
      { id: 'somnath', name: 'Somnath Temple', location: 'Gujarat', image: 'https://images.unsplash.com/photo-1605640840605-14ac1855827b?auto=format&fit=crop&w=600&q=80' },
      { id: 'meenakshi', name: 'Meenakshi Temple', location: 'Tamil Nadu', image: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?auto=format&fit=crop&w=600&q=80' }
    ]
  },
  'jagannath': {
    id: 'jagannath',
    name: 'Jagannath Puri Temple',
    location: 'Puri, Odisha',
    deity: 'Lord Jagannath',
    rating: 4.9,
    heroImage: 'https://images.unsplash.com/photo-1578894381163-e72c17f3fd49?auto=format&fit=crop&w=1200&q=80',
    description: 'The Jagannath Temple in Puri, Odisha, is one of the Char Dham pilgrimage sites and famous for its annual Rath Yatra. Dedicated to Lord Jagannath, along with his siblings Balabhadra and Subhadra, it attracts millions of devotees from across India. The temple architecture is a remarkable example of Kalinga style and stands as a symbol of Odisha\'s rich cultural heritage.',
    timings: 'Open: 5:00 AM – 10:00 PM',
    visitors: '20,000+ devotees visit daily',
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.39272718857!2d85.816369515004!3d19.813009987091007!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a19c7982a2bc8b1%3A0x7d3f7e2b5f3d7f7f!2sJagannath%20Temple%2C%20Puri!5e0!3m2!1sen!2sin!4v1674567890123',
    relatedTemples: [
      { id: 'kashi', name: 'Kashi Vishwanath', location: 'Uttar Pradesh', image: 'https://images.unsplash.com/photo-1581089781785-603411fa81e2?auto=format&fit=crop&w=600&q=80' },
      { id: 'somnath', name: 'Somnath Temple', location: 'Gujarat', image: 'https://images.unsplash.com/photo-1605640840605-14ac1855827b?auto=format&fit=crop&w=600&q=80' },
      { id: 'meenakshi', name: 'Meenakshi Temple', location: 'Tamil Nadu', image: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?auto=format&fit=crop&w=600&q=80' }
    ]
  },
  'vaishno-devi': {
    id: 'vaishno-devi',
    name: 'Vaishno Devi Temple',
    location: 'Katra, Jammu & Kashmir',
    deity: 'Goddess Vaishno Devi',
    rating: 4.9,
    heroImage: 'https://images.unsplash.com/photo-1605640840605-14ac1855827b?auto=format&fit=crop&w=1200&q=80',
    description: 'The Vaishno Devi Temple is one of the most revered Shakti Peethas, located in the Trikuta Mountains. Millions of devotees undertake the challenging trek to seek blessings from Mata Vaishno Devi. The temple is known for its spiritual significance and the divine energy that surrounds the holy cave.',
    timings: 'Open: 24/7 (All Year Round)',
    visitors: '25,000+ devotees visit daily',
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3338.123456789!2d74.951234567!3d33.031234567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391e1234567890ab%3A0x1234567890abcdef!2sVaishno%20Devi%20Temple!5e0!3m2!1sen!2sin!4v1674567890123',
    relatedTemples: [
      { id: 'kamakhya', name: 'Kamakhya Temple', location: 'Assam', image: 'https://images.unsplash.com/photo-1570197788417-0e82375c9371?auto=format&fit=crop&w=600&q=80' },
      { id: 'meenakshi', name: 'Meenakshi Temple', location: 'Tamil Nadu', image: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?auto=format&fit=crop&w=600&q=80' },
      { id: 'haridwar', name: 'Har Ki Pauri', location: 'Uttarakhand', image: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?auto=format&fit=crop&w=600&q=80' }
    ]
  },
  'haridwar': {
    id: 'haridwar',
    name: 'Har Ki Pauri',
    location: 'Haridwar, Uttarakhand',
    deity: 'Lord Shiva',
    rating: 4.7,
    heroImage: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?auto=format&fit=crop&w=1200&q=80',
    description: 'Har Ki Pauri is a sacred ghat on the Ganges in Haridwar, where devotees perform the evening Ganga Aarti. It is believed that Lord Vishnu left his footprint on a stone here. The ghat is famous for its spiritual significance and the mesmerizing Ganga Aarti ceremony that takes place every evening.',
    timings: 'Open: 4:00 AM – 11:00 PM',
    visitors: '12,000+ devotees visit daily',
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3456.789012345!2d78.123456789!3d29.987654321!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3909a1234567890ab%3A0x1234567890abcdef!2sHar%20Ki%20Pauri!5e0!3m2!1sen!2sin!4v1674567890123',
    relatedTemples: [
      { id: 'kashi', name: 'Kashi Vishwanath', location: 'Uttar Pradesh', image: 'https://images.unsplash.com/photo-1581089781785-603411fa81e2?auto=format&fit=crop&w=600&q=80' },
      { id: 'vaishno-devi', name: 'Vaishno Devi', location: 'Jammu & Kashmir', image: 'https://images.unsplash.com/photo-1605640840605-14ac1855827b?auto=format&fit=crop&w=600&q=80' },
      { id: 'lokhnath', name: 'Lokhnath Temple', location: 'Odisha', image: 'https://images.unsplash.com/photo-1609920658906-8223bd289001?auto=format&fit=crop&w=600&q=80' }
    ]
  },
  'lokhnath': {
    id: 'lokhnath',
    name: 'Lokhnath Temple',
    location: 'Puri, Odisha',
    deity: 'Lord Shiva',
    rating: 4.6,
    heroImage: 'https://images.unsplash.com/photo-1609920658906-8223bd289001?auto=format&fit=crop&w=1200&q=80',
    description: 'The Lokhnath Temple is an ancient Shiva temple in Puri, known for its unique architecture and spiritual significance. The temple is dedicated to Lord Shiva and is considered one of the important pilgrimage sites in Odisha. It attracts devotees from across the country seeking blessings and spiritual peace.',
    timings: 'Open: 5:30 AM – 9:30 PM',
    visitors: '8,000+ devotees visit daily',
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.123456789!2d85.816369515004!3d19.813009987091007!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a19c7982a2bc8b1%3A0x7d3f7e2b5f3d7f7f!2sLokhnath%20Temple!5e0!3m2!1sen!2sin!4v1674567890123',
    relatedTemples: [
      { id: 'jagannath', name: 'Jagannath Puri', location: 'Odisha', image: 'https://images.unsplash.com/photo-1578894381163-e72c17f3fd49?auto=format&fit=crop&w=600&q=80' },
      { id: 'haridwar', name: 'Har Ki Pauri', location: 'Uttarakhand', image: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?auto=format&fit=crop&w=600&q=80' },
      { id: 'somnath', name: 'Somnath Temple', location: 'Gujarat', image: 'https://images.unsplash.com/photo-1605640840605-14ac1855827b?auto=format&fit=crop&w=600&q=80' }
    ]
  },
  'kamakhya': {
    id: 'kamakhya',
    name: 'Kamakhya Temple',
    location: 'Guwahati, Assam',
    deity: 'Goddess Kamakhya',
    rating: 4.8,
    heroImage: 'https://images.unsplash.com/photo-1570197788417-0e82375c9371?auto=format&fit=crop&w=1200&q=80',
    description: 'The Kamakhya Temple is one of the most important Shakti Peethas, dedicated to the goddess of desire. Located on the Nilachal Hill in Guwahati, it is known for its unique architecture and the annual Ambubachi Mela. The temple is a significant pilgrimage site for devotees seeking blessings from the divine feminine energy.',
    timings: 'Open: 5:30 AM – 10:00 PM',
    visitors: '18,000+ devotees visit daily',
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3580.123456789!2d91.712345678!3d26.166666667!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x375a5a1234567890ab%3A0x1234567890abcdef!2sKamakhya%20Temple!5e0!3m2!1sen!2sin!4v1674567890123',
    relatedTemples: [
      { id: 'vaishno-devi', name: 'Vaishno Devi', location: 'Jammu & Kashmir', image: 'https://images.unsplash.com/photo-1605640840605-14ac1855827b?auto=format&fit=crop&w=600&q=80' },
      { id: 'meenakshi', name: 'Meenakshi Temple', location: 'Tamil Nadu', image: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?auto=format&fit=crop&w=600&q=80' },
      { id: 'tirupati', name: 'Tirupati Balaji', location: 'Andhra Pradesh', image: 'https://images.unsplash.com/photo-1605640840605-14ac1855827b?auto=format&fit=crop&w=600&q=80' }
    ]
  },
  'tirupati': {
    id: 'tirupati',
    name: 'Tirupati Balaji Temple',
    location: 'Tirupati, Andhra Pradesh',
    deity: 'Lord Venkateswara',
    rating: 4.9,
    heroImage: 'https://images.unsplash.com/photo-1605640840605-14ac1855827b?auto=format&fit=crop&w=1200&q=80',
    description: 'The Tirupati Balaji Temple is one of the richest temples in the world, dedicated to Lord Venkateswara. Located in the Tirumala hills, it attracts millions of devotees annually. The temple is known for its magnificent architecture, spiritual significance, and the famous Laddu prasadam offered to devotees.',
    timings: 'Open: 3:00 AM – 12:00 AM',
    visitors: '50,000+ devotees visit daily',
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.123456789!2d79.345678901!3d13.678901234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a4d4b1234567890ab%3A0x1234567890abcdef!2sTirupati%20Balaji%20Temple!5e0!3m2!1sen!2sin!4v1674567890123',
    relatedTemples: [
      { id: 'jagannath', name: 'Jagannath Puri', location: 'Odisha', image: 'https://images.unsplash.com/photo-1578894381163-e72c17f3fd49?auto=format&fit=crop&w=600&q=80' },
      { id: 'kamakhya', name: 'Kamakhya Temple', location: 'Assam', image: 'https://images.unsplash.com/photo-1570197788417-0e82375c9371?auto=format&fit=crop&w=600&q=80' },
      { id: 'golden-temple', name: 'Golden Temple', location: 'Punjab', image: 'https://images.unsplash.com/photo-1609920658906-8223bd289001?auto=format&fit=crop&w=600&q=80' }
    ]
  },
  'golden-temple': {
    id: 'golden-temple',
    name: 'Golden Temple',
    location: 'Amritsar, Punjab',
    deity: 'Sikh Shrine',
    rating: 4.9,
    heroImage: 'https://images.unsplash.com/photo-1609920658906-8223bd289001?auto=format&fit=crop&w=1200&q=80',
    description: 'The Golden Temple, also known as Sri Harmandir Sahib, is the holiest Sikh shrine. Its golden dome and serene Sarovar (holy tank) create a mesmerizing spiritual atmosphere. The temple is open to people of all faiths and serves free meals (Langar) to thousands of visitors daily, embodying the Sikh principles of equality and service.',
    timings: 'Open: 24/7 (All Year Round)',
    visitors: '30,000+ devotees visit daily',
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3404.123456789!2d74.876543210!3d31.620123456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391964aa1234567890ab%3A0x1234567890abcdef!2sGolden%20Temple!5e0!3m2!1sen!2sin!4v1674567890123',
    relatedTemples: [
      { id: 'tirupati', name: 'Tirupati Balaji', location: 'Andhra Pradesh', image: 'https://images.unsplash.com/photo-1605640840605-14ac1855827b?auto=format&fit=crop&w=600&q=80' },
      { id: 'kashi', name: 'Kashi Vishwanath', location: 'Uttar Pradesh', image: 'https://images.unsplash.com/photo-1581089781785-603411fa81e2?auto=format&fit=crop&w=600&q=80' },
      { id: 'haridwar', name: 'Har Ki Pauri', location: 'Uttarakhand', image: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?auto=format&fit=crop&w=600&q=80' }
    ]
  },
  'somnath': {
    id: 'somnath',
    name: 'Somnath Temple',
    location: 'Gujarat',
    deity: 'Lord Shiva',
    rating: 4.7,
    heroImage: 'https://images.unsplash.com/photo-1605640840605-14ac1855827b?auto=format&fit=crop&w=1200&q=80',
    description: 'The Somnath Temple is the first among the twelve Jyotirlingas of Lord Shiva, located by the Arabian Sea in Gujarat. The temple has been destroyed and rebuilt several times throughout history, symbolizing the resilience of faith. It is one of the most sacred pilgrimage sites for Shiva devotees.',
    timings: 'Open: 6:00 AM – 9:00 PM',
    visitors: '22,000+ devotees visit daily',
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3678.123456789!2d70.409876543!3d20.887654321!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3959c1234567890ab%3A0x1234567890abcdef!2sSomnath%20Temple!5e0!3m2!1sen!2sin!4v1674567890123',
    relatedTemples: [
      { id: 'kashi', name: 'Kashi Vishwanath', location: 'Uttar Pradesh', image: 'https://images.unsplash.com/photo-1581089781785-603411fa81e2?auto=format&fit=crop&w=600&q=80' },
      { id: 'lokhnath', name: 'Lokhnath Temple', location: 'Odisha', image: 'https://images.unsplash.com/photo-1609920658906-8223bd289001?auto=format&fit=crop&w=600&q=80' },
      { id: 'haridwar', name: 'Har Ki Pauri', location: 'Uttarakhand', image: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?auto=format&fit=crop&w=600&q=80' }
    ]
  },
  'meenakshi': {
    id: 'meenakshi',
    name: 'Meenakshi Temple',
    location: 'Madurai, Tamil Nadu',
    deity: 'Goddess Meenakshi',
    rating: 4.8,
    heroImage: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?auto=format&fit=crop&w=1200&q=80',
    description: 'The Meenakshi Temple is a historic temple dedicated to Goddess Meenakshi with stunning Dravidian architecture. The temple complex features 14 colorful gopurams (towers) and thousands of sculptures. It is one of the most important pilgrimage sites in South India and a masterpiece of Tamil architecture.',
    timings: 'Open: 5:00 AM – 12:30 PM, 4:00 PM – 9:30 PM',
    visitors: '35,000+ devotees visit daily',
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3930.123456789!2d78.119876543!3d9.919876543!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b00c1234567890ab%3A0x1234567890abcdef!2sMeenakshi%20Temple!5e0!3m2!1sen!2sin!4v1674567890123',
    relatedTemples: [
      { id: 'vaishno-devi', name: 'Vaishno Devi', location: 'Jammu & Kashmir', image: 'https://images.unsplash.com/photo-1605640840605-14ac1855827b?auto=format&fit=crop&w=600&q=80' },
      { id: 'kamakhya', name: 'Kamakhya Temple', location: 'Assam', image: 'https://images.unsplash.com/photo-1570197788417-0e82375c9371?auto=format&fit=crop&w=600&q=80' },
      { id: 'tirupati', name: 'Tirupati Balaji', location: 'Andhra Pradesh', image: 'https://images.unsplash.com/photo-1605640840605-14ac1855827b?auto=format&fit=crop&w=600&q=80' }
    ]
  }
};